import React from 'react';
import styles from '../../Invoicing.module.css';
import { CheckIcon } from '../../icons';

const left = [
  'Add your logo and brand colors',
  'Drag-and-drop editing',
  'Create once and duplicate',
  'Change sender or add recipients',
  'Send to multiple recipients',
];

const right = [
  'Automatic receipts for processed payments',
  'Saved payment methods',
  'Filter by invoice status',
  'Hover an invoice to view details',
  'Turn invoices into a recurring schedule',
];

const Capabilities = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />All the details</span>
        <h2>Everything in Fyntiq invoicing.</h2>
      </div>
      <div className={`${styles.capabilitiesGrid} ${styles.sr}`} data-sr>
        <ul className={styles.fList}>
          {left.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
        <ul className={styles.fList}>
          {right.map((t) => <li key={t}><CheckIcon />{t}</li>)}
        </ul>
      </div>
    </div>
  </section>
);

export default Capabilities;
